/* eslint-disable max-statements */
/* eslint-disable complexity */
import React from "react";
import { useHistory, useLocation } from "react-router-dom";

import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { appUrl, getLogoURL } from "../../../constants/url-constants";
import templateStringInterpolate from "../../../utils/helpers/template-string-interpolate";
import { carDetailUrlAu } from "../../../utils/helpers/get-detail-page-url";

const getCarName = ({
    year,
    make,
    model,
    appointmentId}) => ({carName: `${year || ""} ${make || ""} ${model || ""}`,
    carId: appointmentId

});

const MetaTagsCarListingV2 = ({
    metaContent = {},
    dynamicContent = {},
    carListing,
    selectedFilters = [],
    searchedFilter = ""
}) => {
    const history = useHistory();
    const baseUrl = appUrl();
    const location = useLocation();
    const { pathname: url } = location;
    const {search} = history.location;

    const {
        title = "",
        description = "",
        keywords = "",
        params = {}
    } = metaContent || {};

    const {
        metaTitleTag = "",
        metaDescription = ""
    } = dynamicContent || {};

    const metaTitle = templateStringInterpolate(metaTitleTag || title, params);
    const metaDescriptionTag = templateStringInterpolate(metaDescription || description, params);
    const metaKeywords = templateStringInterpolate(keywords, params);
    const isDynamicFilterPage = (selectedFilters.length > 0 || searchedFilter) && search ? true : false;

    const carListItemSchema = carListing.map((item, index) => {
        const {carName, carId} = item ? getCarName(item) : {};
        const {absoluteURL} = carDetailUrlAu({carName, carId});
        return ({
            "@type": "ListItem",
            "position": index + 1,
            "name": carName,
            "url": absoluteURL
        });
    });

    /**
     * HANDLED SEPARATELY IN <BuyCarBreadcrumb/>
     */
    //const schema = JSON.stringify(
    //    {
    //        "@context": "http://schema.org",
    //        "@type": "BreadcrumbList",
    //        "itemListElement": [
    //            {
    //                "@type": "ListItem",
    //                "position": "1",
    //                "name": "Home",
    //                "item": `${appUrl()}/${countryCode}`
    //            },
    //            {
    //                "@type": "ListItem",
    //                "position": "2",
    //                "name": cityName,
    //                "item": `${appUrl()}${location.pathname}`
    //            }
    //        ]
    //    }
    //);

    const listSchema = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "ItemList",
        "itemListElement": carListItemSchema
    });

    let canonicalUrl = `${appUrl()}${location.pathname}`;
    if (location.pathname[location.pathname.length - 1] !== "/") {
        canonicalUrl += "/";
    }

    return (
        <Helmet script={[
            //{
            //    type: "application/ld+json",
            //    innerHTML: schema
            //},
            {
                type: "application/ld+json",
                innerHTML: listSchema
            }
        ]}>
            {isDynamicFilterPage ?
                <meta  name="ROBOTS" content="NOINDEX,NOFOLLOW"/>
                :
                <meta name="ROBOTS" content="INDEX,FOLLOW" />
            }
            <title>{metaTitle}</title>
            <meta name="title" content={metaTitle} />
            <meta name="description" content={metaDescriptionTag} />
            { metaKeywords && <meta name="keywords" content={metaKeywords} /> }
            <meta property="og:title" content={metaTitle} />
            <meta property="og:description" content={metaDescriptionTag} />
            <meta property="og:url" content={`${baseUrl}${url}`} />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Cars24" />
            <meta property="og:image" content={getLogoURL()} />
            <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
            <link href={canonicalUrl.toLocaleLowerCase()} rel="canonical" />
        </Helmet>
    );
};

MetaTagsCarListingV2.propTypes = {
    metaContent: PropTypes.object,
    dynamicContent: PropTypes.object,
    location: PropTypes.object,
    cityName: PropTypes.string.isRequired,
    countryCode: PropTypes.string,
    carListing: PropTypes.array,
    selectedFilters: PropTypes.array,
    searchedFilter: PropTypes.string
};

export default MetaTagsCarListingV2;
